// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__33aaE","col":"styles_col__38YDB"};